import Swal from "sweetalert2";

const vars = {
  background: "#E0E0E0",
  cancelButtonColor: "#5A3278",
  confirmButtonColor: "#5A3278",
  denyButtonColor: "#5A3278",
  iconColor: "#5A3278",
};

function fatalError(api, reason) {
  return Swal.fire({
    ...vars,
    icon: "error",
    title: "Oops...",
    text: "Encontramos un error y debemos reiniciar el registro",
  }).then(() => {
    if (api) {
      api.log(reason, "Fatal error");
    }
    window.location.reload();
  });
}

function commonError(reason, callback) {
  return Swal.fire({
    ...vars,
    icon: "error",
    title: "Oops!",
    text: reason,
  }).then(() => {
    if (callback) callback();
    else window.location.reload();
  });
}

function successMessage(reason) {
  return Swal.fire({
    ...vars,
    icon: "success",
    title: "",
    text: reason,
  });
}

function infoMessage(reason) {
  return Swal.fire({
    ...vars,
    icon: "info",
    title: "Información",
    text: reason,
  });
}

function withInputAndCall(title, message, confirmText, call, validator) {
  return Swal.fire({
    ...vars,
    title: title,
    text: message,
    input: "text",
    inputAttributes: {
      autocapitalize: "off",
    },
    cancelButtonText: "Cancelar",
    inputValidator: validator,
    showCancelButton: true,
    confirmButtonText: confirmText,
    showLoaderOnConfirm: true,
    preConfirm: (txt) => call(txt),
    allowOutsideClick: () => !Swal.isLoading(),
  });
}
export {
  fatalError,
  commonError,
  infoMessage,
  successMessage,
  withInputAndCall,
};
